import React, { useEffect, useContext } from 'react';
import _get from 'lodash/get';
import { useHistory } from 'react-router';
import SourceContext from 'helpers/SourceContext';
import useSource from 'pages/Directory/helpers/useSource';
import makeSourceCreateBaseUrl from 'pages/Directory/helpers/makeSourceCreateBaseUrl';
import SelectGroups from './SelectGroups';
import { SourceType } from 'types/Source';

import {
  UPLOAD_CSV_URL,
  AUTHORIZE_DATA_ACCESS_URL,
  SOURCE_WIZARD_BASE_URL,
  CHOOSE_SOURCE_TYPE_URL,
} from 'pages/Directory/consts';

function Container() {
  const history = useHistory();
  const sourceContext = useContext(SourceContext);
  const { sourceInfo } = sourceContext;
  const { directoryId, sourceId, type } = sourceInfo;
  const baseUrl = makeSourceCreateBaseUrl(directoryId, sourceId);
  const source = useSource(sourceId);
  const sourcesWithGroups = [SourceType.AZURE_AD, SourceType.GOOGLE];
  const canSelectGroups = sourcesWithGroups.includes(type);

  useEffect(() => {
    if (type === SourceType.CSV) {
      history.push(`${baseUrl}${UPLOAD_CSV_URL}`);
    }

    if (canSelectGroups && !_get(source, ['authorizationStatus', 'isAuthorized'], false)) {
      history.push(`${baseUrl}${AUTHORIZE_DATA_ACCESS_URL}`);
    }

    if (!canSelectGroups) {
      history.push(`${SOURCE_WIZARD_BASE_URL}${CHOOSE_SOURCE_TYPE_URL}`);
    }
  }, []);

  return canSelectGroups ? <SelectGroups /> : null;
}

export default Container;
